import React, { Component } from "react";

class Pagebuttons extends Component {
  constructor(props) {
    super(props);
    
    this.state = {

    }
  }
  
};

export default Pagebuttons;